import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useAtom } from 'jotai';
import { fiberSitePlanningViewMode } from '../../common/atom/atoms';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const FiberSitePlanningHeader = () => {
  const [viewMode, setViewMode] = useAtom(fiberSitePlanningViewMode);
  const navigate = useNavigate();

  const handleChange = (_, newValue) => {
    if (newValue !== null) {
      setViewMode(newValue);
      // Data fetching is handled by the main component's useEffect
    }
  };
  return (
    <>
      <div
        style={{
          width: '100%',
          padding: '0px 2%',
          display: 'flex',
          marginTop: '-1%',
          justifyContent: 'space-between',
          backgroundColor: '#fff',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: '20px' }}>
            <div
              style={{
                padding: 8,
                background: '#f7f7f7',
                boxShadow: '0px 0px 30px 2px rgba(0, 0, 0, 0.05)',
                borderRadius: 8,
                height: 30,
                width: 30,
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              onClick={() => navigate('/rov')}
            >
              <ArrowBackIosNewIcon style={{ fontSize: 18, color: '#1C274C' }} />
            </div>
            <div style={{ color: 'black', fontSize: 20, fontWeight: '500' }}>FTTS Site List</div>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={handleChange}
            sx={{
              background: '#F8E8E9',
              borderRadius: '8px',
              padding: '4px',
              marginTop: '20px',
              gap: '8px',
              width: 'fit-content',
              '& .MuiToggleButtonGroup-grouped': {
                border: 'none',
                textTransform: 'none',
                fontSize: 14,
                fontFamily: 'Roboto',
                fontWeight: 500,
                borderRadius: '6px !important',
                padding: '7px 11px',
                color: '#192126',
                backgroundColor: 'transparent',
                '&.Mui-selected': {
                  backgroundColor: '#BD1D23',
                  color: '#F8E8E9',
                  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.10)',
                },
                '&:hover': {
                  backgroundColor: '#D79B9D',
                  color: '#F8E8E9',
                },
              },
            }}
          >
            <ToggleButton value="overview">Overview</ToggleButton>
            <ToggleButton value="detailed">Detailed</ToggleButton>
          </ToggleButtonGroup>
        </div>
      </div>
    </>
  );
};
